import { render, staticRenderFns } from "./ImportarGruposDialog.vue?vue&type=template&id=2efe37bd"
import script from "./ImportarGruposDialog.vue?vue&type=script&lang=js"
export * from "./ImportarGruposDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports